export default "__VITE_ASSET__7c784201__"